import 'firebase/auth'
import { observer } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import styled from 'styled-components'

import { AnonymousGameRoute } from '../context/anonymous-game-route'
import { useGameContext } from '../context/game-context'
import { JumbotronMusic } from './components/JumbotronMusic'
import { JumbotronNumbers } from './components/JumbotronNumbers'
import { JumbotronTrivia } from './components/JumbotronTrivia'

export const JumbotronRoute = observer(function JumbotronRoute(): React.ReactElement {
  return (
    <AnonymousGameRoute>
      <Helmet>
        <title>Jumbotron | Rockstar Bingo</title>
      </Helmet>
      <Jumbotron />
    </AnonymousGameRoute>
  )
})

const Jumbotron = observer(function Jumbotron(): React.ReactElement {
  const { gameData } = useGameContext()

  useEffect(() => {
    document.documentElement.classList.remove('light')
    document.documentElement.classList.add('dark')
  }, [])

  const {
    enableBrandImage,
    enableCurrentLetter,
    enableGameCode,
    enableQRCode,
    enableQRCodeFullscreen
  } = gameData.jumbotron

  const showCurrentLetter = enableCurrentLetter && gameData.currentItemIndex !== null

  const hideGameInfo = enableQRCode && enableQRCodeFullscreen

  const showGameInfo =
    [enableBrandImage, enableGameCode, enableQRCode, showCurrentLetter].some(
      setting => setting === true
    ) && !hideGameInfo

  if (gameData.type === 'numbers') {
    return (
      <JumbotronNumbers
        enableBrandImage={enableBrandImage}
        enableGameCode={enableGameCode}
        enableQRCode={enableQRCode}
        enableQRCodeFullscreen={enableQRCodeFullscreen}
        showGameInfo={showGameInfo}
      />
    )
  }

  if (gameData.type === 'trivia') {
    return (
      <JumbotronTrivia
        enableBrandImage={enableBrandImage}
        enableGameCode={enableGameCode}
        enableQRCode={enableQRCode}
        enableQRCodeFullscreen={enableQRCodeFullscreen}
        showCurrentLetter={showCurrentLetter}
        showGameInfo={showGameInfo}
      />
    )
  }

  return <JumbotronMusic showCurrentLetter={showCurrentLetter} showGameInfo={showGameInfo} />
})
